<template>
	<div class="main">
		<div class="box">
			<Header ref="header"></Header>
			<img class="loading" :src="gameData.topBgImage" alt="">
			<div class="item_Options">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="position" ref="iframeContainer" style="width:100%; padding:0; overflow:hidden; position:relative;">
						<div v-if="isLoading" class="loading-progress">
							<div class="progress-bar"></div>
						</div>
						<iframe 
							ref="activityIframe"
							:src="getActivityUrl()" 
							style="width:100%; border:none;"
							scrolling="no"
							frameborder="0"
							@load="handleIframeLoad">
						</iframe>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import ConfirmOrder from '../components/confirmOrder.vue'
import axios from 'axios'
import {
	isEmpty,
	Base64
} from '../utils/index.js'

const ACTVITY_URL_MAP = {
	cztxtw: "https://cztxtw.dustyx.com/activity/index.html"
}

export default {
	name: 'index',
	components: {
		Header,
		Footer,
		UserInfo,
		ConfirmOrder
	},
	data() {
		return {
			gameData: this.$store.state.gameData,
			hasLogin: this.$session.hasLogin(),
			loginData: this.$cache.getLoginData(),
			roleInfo: this.$cache.getRoleInfo(),
			isLoading: true
		}
	},
	mounted() {
		this.changeBackground(this.gameData.bottomBgImage);
		this.$nextTick(() => {
			this.adjustIframeHeight();
			window.addEventListener('resize', this.adjustIframeHeight);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.adjustIframeHeight);
		window.removeEventListener('message', this.handleMessage);
	},
	methods: {
		getActivityUrl(){
			let url = ACTVITY_URL_MAP[this.gameData.gameCode];
			if(this.hasLogin) {
				let sessionToken = {
					userId: this.loginData.userId,
					loginToken: this.loginData.loginToken,
					gameCode: this.gameData.gameCode,
					serverCode: this.roleInfo.serverCode,
					roleId: this.roleInfo.roleId,
					roleName: this.roleInfo.roleName,
					loginTimestamp: this.loginData.loginTimestamp
				}
				let base64Token = Base64.encode(JSON.stringify(sessionToken));
				return url + `?session=${base64Token}`;
			}
			return url;
		},
		changeBackground(newPath) {
			
		},
		adjustIframeHeight() {
			const container = this.$refs.iframeContainer;
			if (container) {
				const containerHeight = container.clientHeight;
				this.$refs.activityIframe.style.height = `${containerHeight}px`;
			}
		},
		handleIframeLoad() {
			this.isLoading = false;
			// 监听来自iframe的消息
			window.addEventListener('message', this.handleMessage);
			
			// 向iframe发送消息请求高度
			const iframe = this.$refs.activityIframe;
			iframe.contentWindow.postMessage('getHeight', '*');
		},
		handleMessage(event) {
			if (typeof event.data === 'object' && event.data.type === 'iframeHeight') {
				this.$refs.activityIframe.style.height = `${event.data.height}px`;
			}
		}
	}
}
</script>
<style>
.loading-progress {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 6px;  /* 增加高度 */
	background: rgba(0,0,0,0.1);  /* 改为半透明背景 */
	z-index: 10;
}

.progress-bar {
	height: 100%;
	width: 0;
	background: linear-gradient(90deg, #FDD100, #FF8C00);  /* 添加渐变效果 */
	box-shadow: 0 0 10px rgba(253,209,0,0.6);  /* 添加发光效果 */
	animation: progress 1.5s ease-in-out infinite;  /* 加快动画速度 */
}

@keyframes progress {
	0% { width: 0; opacity: 0.8; }
	50% { width: 80%; opacity: 1; }
	100% { width: 100%; left: 100%; opacity: 0.8; }
}
</style>